import script from "./ProjectsView.vue?vue&type=script&setup=true&lnag=ts&lang=js"
export * from "./ProjectsView.vue?vue&type=script&setup=true&lnag=ts&lang=js"

import "./ProjectsView.vue?vue&type=style&index=0&id=0d467bf5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d467bf5"]])

export default __exports__